<template>
    <div>
        <v-card>
            <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
                <v-toolbar-title aling="center"
                    >Maestro de Productos</v-toolbar-title
                >
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card flat>
                <PlusMenu :menuItems="menuItems" icon="mdi-cube-outline" />
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="9" sm="9" md="9" class="pb-0">
                                <v-text-field
                                    v-model="search"
                                    append-icon="mdi-magnify"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                    class="mb-4"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" sm="3" md="3" class="pb-0">
                                <v-autocomplete
                                    v-model="inventoryZoneSelect"
                                    :items="processedItemsZones"
                                    label="Zona"
                                    single-line
                                    auto-select-first
                                    :disabled="disableRef"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-data-table
                        :headers="headers"
                        :items="processedItems"
                        :search="search"
                        class="elevation-1 custom-font"
                    >
                        <template v-slot:[`item.estado`]="{ item }">
                            <v-chip :color="getColor(item.estado)" dark>
                                {{ item.estado }}
                            </v-chip>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small class="mr-2" @click="viewItem(item)">
                                mdi-eye
                            </v-icon>
                            <v-icon small class="mr-2" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:no-data> No hay items </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-card>
        <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
                <v-card-title
                    >¿Estás seguro que deseas eliminar este
                    producto?</v-card-title
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                        >Volver</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                        >Eliminar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="crateEditVer" max-width="700px" :key="uniqueKey">
            <createProduct
                :titulo="tituloDialogo"
                :disabledForm="disabledForm"
                :dataForm="dataForm"
                :categories="categories"
                :suppliers="suppliers"
                :key="dataForm.id ? dataForm.id : 0"
                v-on:recibeTickect="recibeTickect"
            />
        </v-dialog>

        <v-dialog v-model="gestStock" max-width="1000px" :key="keyStock">
            <stock
                :products="products"
                :providers="suppliers"
                v-on="{ saveStock, cancelStock }"
            />
        </v-dialog>

        <v-dialog
            v-model="getTransferStock"
            max-width="1000px"
            :key="keyTransferStock"
        >
            <transfer-stock
                :products="products"
                :providers="suppliers"
                v-on="{ executeTransferStock, cancelStock }"
            />
        </v-dialog>

        <v-dialog
            v-model="formMassive"
            max-width="1000px"
            :key="keyFormMassive"
        >
            <upload-masive-inventory
                title="Subir Inventario Masivo"
                :products="products"
                :providers="suppliers"
                :zones="itemsZones"
                v-on="{ executeUploadMassiveInventory, cancelStock }"
            />
        </v-dialog>

        <v-dialog
            v-model="formUpdatePrices"
            max-width="1000px"
            :key="keyFormUpdatePrices"
        >
            <update-prices
                title="Actualizar Precios"
                :products="products"
                v-on="{ executeUpdatePrices, cancelStock }"
            />
        </v-dialog>

        <v-dialog
            v-model="formUploadMassiveProducts"
            max-width="1000px"
            :key="keyFormUploadMassiveProducts"
        >
            <upload-massive-products
                title="Carga Masiva de Productos"
                :products="products"
                :categories="categories"
                :suppliers="suppliers"
                v-on="{ executeCreateProducts, cancelStock }"
            />
        </v-dialog>

        <v-dialog
            v-model="formRegulariceStock"
            max-width="1000px"
            :key="keyFormRegulariceStock"
        >
            <regularice-stock
                title="Regularización de Stock"
                :products="products"
                :zones="itemsZones"
                v-on="{ executeRegularizeInventory, cancelStock }"
            />
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
import api from "../../conf/ruta-base";
import UserProfile from "../../data";
import createProduct from "./create-product.vue";
import PlusMenu from "../../components/plusMenu.vue";
import router from "../../router";
import stock from "./stock.vue";
import transferStock from "./transfer-stock.vue";
import uploadMasiveInventory from "../../components/UploadMasiveInventory.vue";
import updatePrices from "../../components/UpdatePrices.vue";
import uploadMassiveProducts from "../../components/UploadMassiveProducts.vue";
import regulariceStock from "../../components/RegulariceStok.vue";

import {
    uploadFile,
    getProducts,
    getInventoryZonesItems,
    translateInventory,
    regularizeInventory,
} from "@/dataApi";
import generateXls from "../../tools/generatetXls";
import { validateLevelUser } from "../../proccess/utils";
export default {
    components: {
        createProduct,
        PlusMenu,
        stock,
        transferStock,
        uploadMasiveInventory,
        updatePrices,
        uploadMassiveProducts,
        regulariceStock,
    },
    data: () => ({
        dataForm: {},
        disabledForm: false,
        user: UserProfile.getUserData(),
        search: "",
        tituloDialogo: "Nuevo Producto",
        dialog: false,
        crateEditVer: false,
        dialogDelete: false,
        gestStock: false,
        tiposTicket: [
            "Capacitación",
            "Tarea de RRHH",
            "Tarea administrativa",
            "Aviso cambio RRHH",
            "Mantenimiento de equipos",
        ],
        asignacion: ["Cuadrilla", "Persona", "Cargo"],
        estadoTicket: ["No leído", "Abierto", "Resuelto", "Cerrado"],
        headers: [
            { text: "Categoria", value: "category.name" },
            { text: "Codigo", value: "name" },
            { text: "Talla", value: "size" },
            { text: "Descripcion", value: "description" },
            { text: "Precio", value: "price" },
            { text: "Proveedor", value: "supplier.name" },
            { text: "Sex", value: "sex" },
        ],
        products: [],
        inventoryZoneSelect: null,
        itemsZones: [],
        editedIndex: -1,
        editedItem: {},
        apiPath: "products",
        categories: [],
        suppliers: [],
        uniqueKey: 10,
        keyStock: 20,
        getTransferStock: false,
        keyTransferStock: 30,
        menuItems: [],
        formMassive: false,
        keyFormMassive: 40,
        formUpdatePrices: false,
        keyFormUpdatePrices: 50,
        formUploadMassiveProducts: false,
        keyFormUploadMassiveProducts: 60,
        formRegulariceStock: false,
        keyRegulariceStock: 70,
        disableRef: false,
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nuevo ticket" : "Editar ticket";
        },
        processedItems() {
            return this.products.map((product) => ({
                ...product,
                ...this.resolveInventory(
                    this.inventoryZoneSelect,
                    product?.inventory,
                ),
                totalPrice: product.price * product.stockQuantity,
            }));
        },
        processedItemsZones() {
            const zones = [{ text: "TODAS", value: null }];
            return [...zones, ...this.itemsZones];
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },

    created() {
        this.initialize();
        this.menuItems = [
            {
                title: "Agregar Nuevo Producto",
                icon: "mdi-factory",
                action: this.viewDialog,
                roles: `admin,rrhh`,
            },
            {
                title: "Cargar Stock",
                icon: "mdi-open-in-new",
                action: this.viewStock,
                roles: `admin,rrhh`,
            },
            {
                title: "Carga Masiva de Inventario",
                icon: "mdi-file-excel",
                action: this.createMassiveInventory,
                roles: `admin,rrhh`,
            },
            {
                title: "Transferir Stock",
                icon: "mdi-format-horizontal-align-center",
                action: this.viewTransferStock,
                roles: `admin,rrhh`,
            },
            {
                title: "Exportar Excel Productos",
                icon: "mdi-file-excel",
                action: () => this.processExcelProducts(),
                roles: `admin,rrhh`,
            },
            {
                title: "Sets",
                icon: "mdi-cube-unfolded",
                action: this.viewKits,
                roles: `admin,rrhh`,
            },
            {
                title: "Actualizar Precios",
                icon: "mdi-file-excel",
                action: this.createUpdatePrices,
                roles: `admin,rrhh`,
            },
            {
                title: "Maestro de Categorías",
                icon: "mdi-flip-to-front",
                action: this.viewCategories,
                roles: `admin,rrhh,sup`,
            },
            {
                title: "Carga Masiva de Productos",
                icon: "mdi-file-excel",
                action: this.createUploadMassiveProducts,
                roles: `admin,rrhh`,
            },
            {
                title: "Zonas de inventario",
                icon: "mdi-collage",
                action: this.viewZones,
                roles: `admin,rrhh`,
            },
            {
                title: "Regularización de Stock",
                icon: "mdi-file-excel",
                action: this.createRegulariceStock,
                roles: `admin,rrhh`,
            },
        ];
        if (validateLevelUser("admin,rrhh")) {
            this.headers.push(
                { text: "En Existencia", value: "stockQuantity" },
                { text: "Comprometido", value: "quantityLock" },
                { text: "Acciones", value: "actions", sortable: false },
            );
        }
    },

    methods: {
        validateLevelUser,
        async recibeTickect(item) {
            this.crateEditVer = false;
            if (!item) {
                this.close();
                return;
            }
            item = await this.completeAndValidateItem(item);
            if (!item.id) {
                axios.post(api.api + "/products", item).then((response) => {
                    const agregateProduct = this.agregateComplements(
                        response.data,
                    );
                    this.products.push(agregateProduct);
                });
            } else {
                axios
                    .patch(`${api.api}/products/${item.id}`, item)
                    .then((response) => {
                        const newItem = this.agregateComplements(item);
                        Object.assign(this.products[this.editedIndex], newItem);
                    });
            }
        },

        agregateComplements(itemProduct) {
            const category = this.categories.find(
                (cat) => cat.value === itemProduct.categoryId,
            );
            itemProduct.category = { name: category.text, id: category.value };
            const supplier = this.suppliers.find(
                (sup) => sup.value === itemProduct.supplierId,
            );
            itemProduct.supplier = { name: supplier.text, id: supplier.value };
            return itemProduct;
        },

        viewDialog() {
            this.crateEditVer = true;
            this.disabledForm = false;
            this.dataForm = {};
        },

        viewStock() {
            this.keyStock++;
            this.gestStock = true;
        },

        viewTransferStock() {
            this.keyTransferStock++;
            this.getTransferStock = true;
        },

        viewCategories() {
            router.push("/categories");
        },

        viewKits() {
            router.push("/kits");
        },

        viewZones() {
            router.push("/inventories-zone");
        },

        async initialize() {
            this.sincroProducts();
            this.itemsZones = await getInventoryZonesItems();

            axios
                .get(api.api + "/categories")
                .then((r) => {
                    r.data.forEach((cat) => {
                        this.categories.push({
                            text: cat.name,
                            value: cat.id,
                        });
                    });
                    this.categories.sort((a, b) =>
                        a.text.localeCompare(b.text),
                    );
                })
                .catch((error) => {
                    console.log(error);
                });

            axios
                .get(api.api + "/suppliers")
                .then((r) => {
                    r.data.forEach((sup) => {
                        this.suppliers.push({
                            text: sup.name,
                            value: sup.id,
                        });
                    });
                    this.suppliers.sort((a, b) => a.text.localeCompare(b.text));
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        async sincroProducts() {
            const { products } = await getProducts();
            this.products = products;
        },

        getColor(estado) {
            if (estado == "No leído") return "default";
            else if (estado == "Resuelto") return "green";
            else if (estado == "Abierto") return "orange";
            else if (estado == "Cerrado") return "red";
        },

        editItem(item) {
            this.uniqueKey++;

            this.editedIndex = this.products.findIndex(
                (prod) => prod.id === item.id,
            );
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
            this.dataForm = Object.assign({}, item);
            ((this.tituloDialogo = "Editar Producto"),
                (this.crateEditVer = true));
            this.disabledForm = false;
        },

        deleteItem(item) {
            this.editedIndex = this.products.indexOf(item);
            this.editedItem = item;
            this.dialogDelete = true;
        },

        viewItem(item) {
            this.editedIndex = this.products.indexOf(item);
            this.editedItem = item;
            ((this.tituloDialogo = "Ver Producto"), (this.crateEditVer = true));
            this.dataForm = item;
            this.disabledForm = true;
        },

        deleteItemConfirm() {
            this.products.splice(this.editedIndex, 1);
            axios.delete(`${api.api}/products/${this.editedItem.id}`);
            this.editedItem = Object.assign({}, this.defaultItem);
            this.closeDelete();
        },

        close() {
            console.log("cerrando");
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                Object.assign(this.products[this.editedIndex], this.editedItem);
            } else {
                this.products.push(this.editedItem);
            }
            this.close();
        },

        async completeAndValidateItem(item) {
            console.log("item", item, this.editedItem);
            if (!item.description) item.description = "";
            if (!item.stockQuantity) item.stockQuantity = 0;
            if (!item.quantityLock) item.quantityLock = 0;
            item.price = +item.price;
            item.stockQuantity = +item.stockQuantity;
            item.quantityLock = +item.quantityLock;
            item.stockMin = +item.stockMin;
            item.photo = item.chosenFile
                ? await uploadFile(item.chosenFile)
                : this.editedItem.photo == ""
                  ? ""
                  : this.editedItem.photo;
            if (!item.sex) item.sex = "U";
            if (!item.photo) item.photo = "";
            delete item.category;
            delete item.supplier;
            delete item.chosenFile;
            delete item.inventory;
            delete item.totalPrice;
            item.zone = item.zone || "1";
            return item;
        },

        async executeTransferStock(productsTransfer) {
            const items = [];
            productsTransfer.forEach((item) => {
                items.push({
                    productId: item.id,
                    quantity: item.quantity,
                    zoneOriginId: item.zoneOrigin,
                    zoneDestinationId: item.zoneDestination,
                    reference: item.reference,
                });
            });
            await translateInventory({ items });
            this.cancelStock();
            this.sincroProducts();
        },

        async executeUpdatePrices(productsUpdatePrices) {
            this.cancelStock();
            this.sincroProducts();
        },

        async executeCreateProducts(productsCreate) {
            for (const product of productsCreate) {
                await this.recibeTickect(product);
            }
            this.cancelStock();
            this.sincroProducts();
        },

        async executeUploadMassiveInventory(payload) {
            for (const stock of payload) {
                await this.saveStock(stock);
            }
            this.cancelStock();
            this.sincroProducts();
        },

        async executeRegularizeInventory(payload) {
            await regularizeInventory(payload);
            this.cancelStock();
            this.sincroProducts();
        },

        async saveStock(stock) {
            console.log("saveStock", stock);
            this.cancelStock();
            const items = [];
            const movements = [];
            stock.items.map((item) => {
                const basic = {
                    productId: item.id,
                    quantity: item.quantity,
                    zoneId: stock.zone,
                };
                items.push(basic);
                movements.push({
                    ...basic,
                    supplierId: stock.origin,
                    reference: stock.reference,
                    type: "ENTRADA",
                });
            });

            const aggregatedStock = await axios.post(
                api.api + "/inventories/bulk",
                { items },
            );
            if (aggregatedStock) {
                aggregatedStock.data.map((ids) => {
                    const productIndex = this.products.findIndex(
                        (prod) => prod.id === ids.product.id,
                    );
                    if (productIndex !== -1)
                        this.products[productIndex].inventory
                            ? (this.products[productIndex].inventory.quantity =
                                  ids.quantity)
                            : (this.products[productIndex].inventory = {
                                  quantity: ids.quantity,
                              });
                });
                axios.post(api.api + "/inventories/movements", movements);
            }
        },

        cancelStock() {
            console.log("cancelStock");
            this.keyStock++;
            this.keyTransferStock++;
            this.keyFormMassive++;
            this.keyFormUpdatePrices++;
            this.keyRegulariceStock++;
            this.gestStock = false;
            this.getTransferStock = false;
            this.formMassive = false;
            this.formUpdatePrices = false;
            this.formUploadMassiveProducts = false;
            this.formRegulariceStock = false;
        },

        resolveInventory(zoneId, inventory) {
            let stockQuantity = 0;
            let quantityLock = 0;
            if (!inventory) return { stockQuantity, quantityLock };
            if (!zoneId) {
                inventory.forEach((zone) => {
                    stockQuantity += zone.quantity;
                    quantityLock += zone.quantityLock;
                });
            } else {
                const zone = inventory.find((z) => z.zoneId === zoneId);
                if (zone) {
                    stockQuantity = zone.quantity;
                    quantityLock = zone.quantityLock;
                }
            }
            return { stockQuantity, quantityLock };
        },

        createMassiveInventory() {
            this.formMassive = true;
        },

        createUpdatePrices() {
            this.formUpdatePrices = true;
        },

        createUploadMassiveProducts() {
            this.formUploadMassiveProducts = true;
        },

        createRegulariceStock() {
            this.formRegulariceStock = true;
        },
        
        processExcelProducts() {
            // Mapa zonaId → text (excluye "TODAS" con value=null)
            const zoneMap = {};
            this.itemsZones.forEach((z) => {
                zoneMap[z.value] = z.text;
            });

            // Sanitizar campos texto para prevenir Excel formula injection
            // Valores que empiezan con =, +, -, @ son interpretados como fórmulas por Excel
            const sanitize = (val) => {
                const s = String(val ?? '');
                if (/^[=+\-@]/.test(s)) return "'" + s;
                return s;
            };

            const excelData = [];

            this.products.forEach((product) => {
                const cod = sanitize(product.name);
                const nom = sanitize(product.description);
                const talla = sanitize(product.size);
                const genero = sanitize(product.sex);
                const precio = product.price || 0;
                const inv = product.inventory || [];

                if (!inv || inv.length === 0) return;

                // Si hay filtro de zona, exportar solo esa zona
                if (this.inventoryZoneSelect && this.inventoryZoneSelect.value !== null) {
                    const zone = inv.find((z) => z.zoneId === this.inventoryZoneSelect.value);
                    if (zone) {
                        excelData.push({
                            "CODIGO": sanitize(cod),
                            "NOMBRE": sanitize(nom),
                            "TALLA": sanitize(talla),
                            "EXISTENCIA": zone.quantity || 0,
                            "ZONA": sanitize(zoneMap[zone.zoneId]),
                            "GENERO": sanitize(genero),
                            "PRECIO": precio,
                            "TOTAL": (zone.quantity || 0) * precio,
                        });
                    }
                } else {
                    // Sin filtro: una fila por cada zona con inventario
                    inv.forEach((zone) => {
                        excelData.push({
                            "CODIGO": sanitize(cod),
                            "NOMBRE": sanitize(nom),
                            "TALLA": sanitize(talla),
                            "EXISTENCIA": zone.quantity || 0,
                            "ZONA": sanitize(zoneMap[zone.zoneId]),
                            "GENERO": sanitize(genero),
                            "PRECIO": precio,
                            "TOTAL": (zone.quantity || 0) * precio,
                        });
                    });
                }
            });

            generateXls(excelData, "inventario-export");
        }
    },
};
</script>

<style lang="scss">
.combo-parametros {
    .v-select__selections {
        min-height: 56px !important;
    }
}

.theme--dark.v-chip.default {
    background: #f1f1f1;
    color: rgba(0, 0, 0, 0.87);
}

.v-text-field__details {
    display: none;
}

.custom-font {
    font-family: "Your Font Family", sans-serif;
    font-size: 16px;
    /* ajusta el tamaño de la fuente según tus necesidades */
    text-transform: uppercase;
}
</style>
